import { Component } from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd/modal';

@Component({
    selector: 'clink-insert-emoji',
    templateUrl: './insert-emoji.component.html',
})
export class InsertEmojiComponent {
    static config: any = {
        nzContent: InsertEmojiComponent,
        nzMaskClosable: false,
        nzWidth: 500,
        nzFooter: null,
        nzComponentParams: {
            data: {},
        },
    };
    constructor(public modalRef: NzModalRef<InsertEmojiComponent>) {}

    selectEmoji(val): void {
        this.modalRef.close(val.alt);
    }
}
